import FormTranslationContext from "context/FormTranslationContext";
import getObjectValue from "libs/getObjectValue";
import { useContext } from "react";
import NoticeGlossaryInput from "../../components/inputs/NoticeGlossaryInput";
import NoticeTextInput from "../../components/inputs/NoticeTextInput";
import { Collapse } from "@material-ui/core";
import NoticeYesNoInput from "../../components/inputs/NoticeYesNoInput";
import NoticeObjectData from "./NoticeObjectData";
function NoticeProcedureSummary(
    {
        id,
        formikProps
    }) {

    const gId = (name) => id + "." + name;
    const gVal = (name, prefix = true, defaultVal = null) => getObjectValue(prefix ? gId(name) : name, formikProps.values, defaultVal);
    const { getDict } = useContext(FormTranslationContext)
    const updateNotice = getObjectValue('_updateNotice', formikProps.values, true);
    const refersTo = gVal("form.basicData.refersTo", false);
    return (
        <>

            <NoticeGlossaryInput
                id={gId("noticeNature")}
                formikProps={formikProps}
                items={getDict("SL.MO.023")}
                required
            />
            <NoticeYesNoInput
                id={gId("precededByContractOrContractIntentionNotice")}
                formikProps={formikProps}
                required
            />
            <Collapse in={gVal("precededByContractOrContractIntentionNotice") === true}>
                <NoticeTextInput
                    id={gId("ezamowieniaNumber")}
                    formikProps={formikProps}
                    required
                />
            </Collapse>
            <NoticeYesNoInput
                id={gId("ueFunded")}
                formikProps={formikProps}
                required
            />
            <Collapse in={gVal("ueFunded") === true}>
                <NoticeTextInput
                    id={gId("ueProgramName")}
                    formikProps={formikProps}
                    required
                />
            </Collapse>
            <Collapse in={refersTo === "Order"}>
                <NoticeGlossaryInput
                    id={gId("orderRealizationType")}
                    formikProps={formikProps}
                    items={getDict("ENUM.018")}
                    required
                    disabled={updateNotice}
                />
            </Collapse>
            <Collapse in={refersTo === "FrameworkAgreement"}>
                <NoticeGlossaryInput
                    id={gId("frameworkRealizationType")}
                    formikProps={formikProps}
                    items={getDict("ENUM.019")}
                    required
                    disabled={updateNotice}
                />
            </Collapse>
            <NoticeGlossaryInput
                id={gId("orderType")}
                formikProps={formikProps}
                items={getDict("ENUM.002")}
                required
            />
            <NoticeTextInput
                formikProps={formikProps}
                id={gId("orderName")}
                required
            />
            <NoticeObjectData id={gId("noticeObjectData")} formikProps={formikProps} />
        </>
    )
}

NoticeProcedureSummary.propTypes = {};
export default NoticeProcedureSummary;